/**
 * RoadmapItemInfoRemapper
 *
 * Maps RoadmapItemInfoDto (data layer) → RoadmapItemInfoEntity (domain).
 * Flutter source: lib/data/models/roadmap_item_info.dart
 */
import type { RoadmapItemInfoDto } from '@/data/dtos/info/roadmapItemInfoDto';
import type { JsonObject } from '@/data/types/json';
import type { RoadmapItemInfoEntity } from '@/domain/entities/info/roadmapItemInfoEntity';

export class RoadmapItemInfoRemapper {
  static fromDto(dto: RoadmapItemInfoDto): RoadmapItemInfoEntity {
    return { ...dto };
  }

  static fromJson(data: JsonObject): RoadmapItemInfoDto {
    return {
      roadmapItemId: (data['roadmapItemId'] as string | undefined) ?? '',
    };
  }

  static fromJsonList(dataList: JsonObject[]): RoadmapItemInfoDto[] {
    return dataList.map(RoadmapItemInfoRemapper.fromJson);
  }

  /**
   * Serialize for the notification `info.toJson()` payload.
   * Flutter `_$RoadmapItemInfoToJson` emits the single `roadmapItemId` key.
   */
  static toJson(dto: RoadmapItemInfoDto): JsonObject {
    return {
      roadmapItemId: dto.roadmapItemId,
    };
  }
}
